import React from "react";
import { BRAND } from "../mock/mock";
import { useContent } from "../context/ContentContext";

export default function WhatsAppButton() {
  const { brand = BRAND } = useContent();
  return (
    <a
      href={`https://wa.me/${brand.whatsappRaw}`}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20bd5b] flex items-center justify-center shadow-lg hover:shadow-[#25D366]/30 transition-all duration-300 hover:scale-105"
    >
      <svg viewBox="0 0 24 24" className="w-7 h-7 text-white" fill="currentColor">
        <path d="M20.52 3.48A11.93 11.93 0 0 0 12.04 0C5.46 0 .1 5.36.1 11.94c0 2.1.55 4.15 1.6 5.96L0 24l6.27-1.64a11.9 11.9 0 0 0 5.77 1.47h.01c6.58 0 11.93-5.36 11.93-11.94 0-3.19-1.24-6.19-3.46-8.41zM12.05 21.8h-.01a9.83 9.83 0 0 1-5.01-1.37l-.36-.21-3.72.97.99-3.62-.24-.37a9.84 9.84 0 0 1-1.51-5.26c0-5.46 4.45-9.91 9.92-9.91 2.65 0 5.14 1.03 7.01 2.91a9.82 9.82 0 0 1 2.9 7.01c0 5.46-4.45 9.85-9.97 9.85zm5.45-7.39c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.47a9.07 9.07 0 0 1-1.67-2.08c-.17-.3-.02-.46.13-.61.13-.13.3-.34.44-.51.15-.17.2-.29.3-.49.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.87 1.21 3.07c.15.2 2.1 3.21 5.08 4.5.71.31 1.26.49 1.69.63.71.23 1.35.2 1.86.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z"/>
      </svg>
    </a>
  );
}
